module.exports = __webpack_public_path__ + "img/mail.2b20efb3.svg";